module.exports = __webpack_public_path__ + "static/media/admin-dash-graph.8a673a4b.jpg";